export default __webpack_public_path__ + "static/media/05_o_2.2081ef66.jpg";